import React from 'react';
import CustomModal from "../../components/Modal/CustomModal";
import ModuleExportDataApp from "./Functionality/ModuleExportDataApp";
import {CustomDatePicker} from "../CustomDatePicker";

/**
 * @email kpozos@ibl.mx
 * @author Karen Yunuen Pozos Arias
 * @title Full Stack Developer
 *
 * Modal component used to export module data within a selected date range.
 * It allows users to choose a time range and export the data as Excel or PDF.
 *
 * @param {Object} props - Component properties.
 * @param {boolean} props.show - Controls the visibility of the modal.
 * @param {Function} props.onHide - Callback function to close the modal.
 * @param {string} props.title - Title displayed in the modal header.
 * @param {boolean} props.excel - Determines if the export format is Excel (true) or PDF (false).
 * @param {Function} props.endPoint - Function or API handler used to execute the export request.
 * @param {Function} props.renderEndPointBody - Function that builds the request body for the export endpoint.
 * @param {*} props.exportModuleDataOption - Model or configuration that defines what data will be exported.
 *
 * @returns {JSX.Element} Modal component for exporting module data.
 */
const ModuleExportDataModal = (props) => {
    const {
        title,
        onHide,
        excel,
        endPoint,
        renderEndPointBody,
        exportModuleDataOption
    } = props;

    const {
        t,
        item,
        emptyFields,
        isValidRange,
        handleDownload,
        handleChange
    } = ModuleExportDataApp({
        onHide,
        excel,
        endPoint,
        renderEndPointBody,
        exportModuleDataOption
    });

    return (
        <CustomModal
            {...props}
            title={title}
            size="lg"
            cancelButton={true}
            confirmButton={true}
            onConfirm={handleDownload}
            classNameBody="pt-2"
        >
            <div className={"row mt-1"}>
                <div className={"col-12"}>
                    <p className="text-center ibl-font-w-600 font-color-general-950 fs-14px">
                        {t('select_time_range_for_your_custom_report')}
                    </p>
                </div>

                <div className={"col-12 my-4"}>
                    <p className="text-center fs-14px">
                        {t('file')}: <span className={"ibl-font-w-600 font-color-general-950 fs-14px"}>{ excel ? t('excel').toUpperCase() : t('pdf').toUpperCase()}</span>
                    </p>
                </div>
            </div>
            <div className={"row mt-1"}>
                <div className={"col-sm-12 col-md-6"}>
                    <CustomDatePicker
                        id={'dp_med_from'}
                        name={'attendanceStartDate'}
                        disabled={false}
                        onChange={(e) => handleChange({ target: { value: e, name: 'attendanceStartDate' } })}
                        trans={'from'}
                        value={item.attendanceStartDate}
                        required={true}
                        emptyFields={emptyFields}
                        isValid={isValidRange}
                        isValidText={'from_date_must_be_less_than_or_equal_to_the_to_date'}
                        openTo={'day'}
                    />
                </div>

                <div className={"col-sm-12 col-md-6"}>
                    <CustomDatePicker
                        id={'dp_med_to'}
                        name={'attendanceEndDate'}
                        disabled={false}
                        onChange={(e) => handleChange({ target: { value: e, name: 'attendanceEndDate' } })}
                        trans={'to'}
                        value={item.attendanceEndDate}
                        required={true}
                        emptyFields={emptyFields}
                        isValid={isValidRange}
                        isValidText={'from_date_must_be_less_than_or_equal_to_the_to_date'}
                        openTo={'day'}
                    />
                </div>
            </div>
        </CustomModal>
    );
};

export default ModuleExportDataModal;
